import { render, staticRenderFns } from "./MassMediaDesktop.vue?vue&type=template&id=fccde106&scoped=true&"
import script from "./MassMediaDesktop.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MassMediaDesktop.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MassMediaDesktop.vue?vue&type=style&index=0&id=fccde106&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccde106",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fccde106')) {
      api.createRecord('fccde106', component.options)
    } else {
      api.reload('fccde106', component.options)
    }
    module.hot.accept("./MassMediaDesktop.vue?vue&type=template&id=fccde106&scoped=true&", function () {
      api.rerender('fccde106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/pressa/components/desktop/MassMediaDesktop.vue"
export default component.exports